<template>
  <div class="box">
    <v-server-table 
      ref="datatable" 
      :url="api" 
      :name="tableName" 
      :columns="columns" 
      :options="options"/>

    <div 
      id="discount-popup" 
      class="modal fade inactive" 
      data-backdrop="false">
      <div class="right w-xxl white b-l">
        <discount-form 
          ref="form" 
          :discount="discount"/>
      </div>
    </div>

  </div>
</template>

<script>
import Auth from '@js/plugins/auth';
import VuetableCheckbox from '../../../components/vuetable2/checkbox/state';
import discountForm from '../../../franchise_component/setting/discount/form.vue';

const TableName = 'VUETABLE_DISCOUNT';

export default {
    components: {
        discountForm,
    },

    props: {
        currency: {
            type: String,
            default: 'RM',
        },
    },

    data() {
        var that = this;

        let canManageDiscounts = Auth.hasPermissionTo(
            'franchise_manage_discounts',
        );

        let actionButtons = [
            {
                title: 'Create Discount',
                action: () => {
                    this.show_popup(null);
                },
            },
        ];

        if (!canManageDiscounts) {
            actionButtons = [];
        }

        return {
            discount: {},
            tableName: TableName,
            api: Laroute.route('franchise.setting.discount.index'),
            columns: [
                'name',
                'mode',
                'amount',
                'available_from',
                'available_to',
                'tags',
            ],
            options: {
                checkbox: canManageDiscounts,
                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.setting.discount.delete',
                    ),
                    delete_title: 'Delete Discounts',
                },
                customFilters: ['outlet_id'],
                initFilters: { outlet_id: that.$store.getters.activeOutlet },
                sortable: [
                    'name',
                    'mode',
                    'amount',
                    'available_from',
                    'available_to',
                ],
                orderBy: { column: 'name', ascending: 1 },
                texts: {
                    count:
                        'Showing {from} to {to} of {count} records|{count} records|One record',
                    limit: 'Records per page :',
                    filterPlaceholder: 'Search Discounts',
                },
                perPageValues: [5, 10, 20, 40, 80],
                headings: {
                    parent: 'Parent Discount',
                    items: 'Products',
                },
                csv_url: Laroute.route(
                    'franchise.setting.discount.exportAsFile',
                    { type: 'CSV' },
                ),
                pdf_url: Laroute.route(
                    'franchise.setting.discount.exportAsFile',
                    { type: 'PDF' },
                ),
                actionButtons: actionButtons,
                rowClassCallback: row => 'pointer',
                rowClickCallback: that.show_popup,
                templates: {
                    mode(h, row) {
                        return require('./colums/mode.jsx')(h, row, that);
                    },
                    available_from(h, row) {
                        return require('./colums/available_from.jsx')(
                            h,
                            row,
                            that,
                        );
                    },
                    available_to(h, row) {
                        return require('./colums/available_to.jsx')(
                            h,
                            row,
                            that,
                        );
                    },
                    amount(h, row) {
                        return require('./colums/amount.jsx')(h, row, that);
                    },
                    tags(h, row) {
                        return require('./colums/tags.jsx')(h, row, that);
                    },
                },
            },
        };
    },

    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
        searchQuery() {
            return this.$refs.datatable.query;
        },
    },

    watch: {
        activeOutlet: function() {
            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'outlet_id',
                value: this.activeOutlet,
            });
        },
    },

    created() {
        this.$store.registerModule(`CHECKBOX_${TableName}`, VuetableCheckbox);
    },

    methods: {
        init_discount() {
            this.discount = {
                id: 0,
                name: '',
                mode: 3,
                amount: '0.00',
                tags: [],
                available_to: null,
                available_from: null,
                outlets: [],
            };
            this.$refs.form.clearTimePicker();
        },

        get_discount(id) {
            var that = this;
            this.$http.get(this.getDiscountApi(id)).then(response => {
                let data = response.data.data;
                that.discount = data;
                that.$refs.form.setTimePickerValue(data);
                that.show_modal();
            });
        },

        show_popup(row) {
            if (row != null) {
                this.get_discount(row.id);
            } else {
                this.init_discount();
                this.show_modal();
            }
        },

        refresh() {
            this.$refs.datatable.setFilter(this.searchQuery);
        },

        show_modal() {
            $('#discount-popup').modal('show');
        },

        getDiscountApi(id) {
            return Laroute.route('franchise.setting.discount.show', { id: id });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/discount/datatable.vue